import type * as React from 'react'
import { createContext } from 'react'
import type { Location } from '../hooks/useHereLocation'

/** Bounding box defined by its north, south, east, and west edges. */
export type MapBounds = {
  north: number
  south: number
  east: number
  west: number
}

export type HereMapContextType = {
  map: H.Map | undefined
  zoomIn: VoidFunction
  zoomOut: VoidFunction
  resetPosition: VoidFunction
  mapRef: React.RefObject<HTMLDivElement | null> | undefined
  setCenter: (location: Location, animate?: boolean) => void
  setViewport: (
    opts: MapBounds | { center: Location; zoom: number },
    animate?: boolean,
  ) => void
  getZoom: () => number
  getCenter: () => Location | undefined
  screenToGeo: (x: number, y: number) => Location | undefined
  resize: () => void
}

export const HereMapContext = createContext<HereMapContextType | null>(null)
